import { bareIzteachClient } from '../clients';
import { retryColdStart } from '../core/coldStart';
import { libraryVendorId } from '../session';
import type { IztExamQuestion, IztExamSubmission } from '../types';

// IZTeach examination-service GET /submission and /question are public; LTV students sit exams on the content tenant
export const ExamSubmissionRepository = {
  /** One exam's attempts, narrowed to the roster pattern; `exam` is indexed, an email-only filter times the gateway out. */
  listByExam: (examId: string, emailPattern: string, limit: number) =>
    retryColdStart(() =>
      bareIzteachClient('exam')
        .get('/submission', { params: { vendorId: libraryVendorId(), exam: examId, email_contain: emailPattern, _limit: limit } })
        .then((res) => (Array.isArray(res.data) ? res.data as IztExamSubmission[] : [])),
    ),

  questionsOf: (examId: string) =>
    retryColdStart(() =>
      bareIzteachClient('exam')
        .get('/question', { params: { vendorId: libraryVendorId(), exam: examId, _limit: 500 } })
        .then((res) => (Array.isArray(res.data) ? res.data as IztExamQuestion[] : [])),
    ),
};

export default ExamSubmissionRepository;
